<template>
  <v-app-bar
    app
    clipped-left
    clipped-right
    flat
    color="#262b3e"
    :class="{
      'px-4': !mobile,
      'px-0': mobile,
      'align-center': mobile
    }"
  >
    <v-row v-if="!mobile" class="align-center">
      <v-btn icon @click="setMini()"
        ><v-icon class="white--text">mdi-menu</v-icon></v-btn
      >
      <a class="my-auto mx-4" href="/app/#/dashboard">
        <v-avatar size="40">
          <img id="logo" :src="logoUrl" />
        </v-avatar>
      </a>
      <p class="white--text" style="white-space: pre">S P A C E P A C K P H</p>

      <!--  <v-spacer></v-spacer>
      <v-breadcrumbs
        divider=">"
        :items="breadcrumbs"
        dark
        class="white--text"
      >
      </v-breadcrumbs> -->
      <v-spacer></v-spacer>
      <div class="selection-container">
        <v-select
          v-model="currentProperty"
          :items="properties"
          hide-details
          dense
          dark
          outlined
          @change="changeCurrentProperty"
        >
          <template v-slot:selection="{ item }">
            <div class="d-flex flex-row text-truncate" style="max-width: 100%">
              <v-icon small>mdi-home-city-outline</v-icon>
              <p class="body-2 ml-2 white--text">{{ item.text }}</p>
            </div>
          </template>
          <template v-slot:append-item>
            <div class="d-flex flex-column align-center pt-2">
              <v-btn
                small
                class="ma-auto"
                :disabled="checkPropertyLimit"
                color="primary"
                depressed
                @click="redirectCreateProperty"
              >
                <v-icon x-small class="mr-2">mdi-plus</v-icon>New Property
              </v-btn>
              <p v-if="checkPropertyLimit" class="caption red--text">
                Property Limit Reached
              </p>
            </div>
          </template>
        </v-select>
      </div>

      <div class="ml-6">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="redirectDocumentation">
              <v-icon color="white" small>mdi-help-circle-outline</v-icon>
            </v-btn>
          </template>
          <p class="white--text">Check out our newest features!</p>
        </v-tooltip>

        <v-menu v-model="notificationOpen" left bottom offset-y max-width="500">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-badge :content="notificationItems.length || '0'" overlap>
                <v-icon color="white" small>mdi-bell</v-icon>
              </v-badge>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item
              v-for="(item, index) in notificationItems"
              :key="'appBarNotification_' + index"
              :two-line="item.twoLine"
              :three-line="!item.twoLine"
              dense
              @click="item.action"
            >
              <v-list-item-avatar>
                <v-icon :color="item.iconColor" v-text="item.icon"></v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
                <v-list-item-subtitle
                  v-text="item.subtitle"
                ></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-action-text
                  v-text="item.date"
                ></v-list-item-action-text>
                <v-btn small icon @click="removeNotification(item)">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item v-if="!notificationItems.length" one-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >No notifications to show</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu left bottom open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" text v-on="on">
              <v-avatar size="30" color="grey">
                <v-img
                  v-if="user.profilePicture"
                  :src="user.profilePicture"
                ></v-img>
                <v-icon v-else dark small>mdi-account</v-icon>
              </v-avatar>
              <p class="caption white--text ml-2">{{ userName }}</p>
            </v-btn>
          </template>

          <v-list class="py-0" dense>
            <v-list-item
              v-for="(item, index) in menuItems"
              :key="'appbar_top_' + index"
              @click="item.action"
            >
              <v-list-item-icon class="mr-2">
                <v-icon small>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item
              v-for="(item, index) in menuItemsBottom"
              :key="'appbar_bottom_' + index"
              @click="item.action"
            >
              <v-list-item-icon class="mr-2">
                <v-icon small>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-row>

    <v-row v-else>
      <!-- MOBILE VIEW CODE -->
      <v-spacer></v-spacer>

      <v-app-bar-nav-icon>
        <v-btn icon @click="setMini()"
          ><v-icon class="white--text">mdi-menu</v-icon></v-btn
        >
      </v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <div>
        <!-- Notifs -->
        <v-menu v-model="notificationOpen" left bottom offset-y max-width="500">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-badge :content="notificationItems.length || '0'" overlap>
                <v-icon color="white" small>mdi-bell</v-icon>
              </v-badge>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item
              v-for="(item, index) in notificationItems"
              :key="'appBarNotification_' + index"
              :two-line="item.twoLine"
              :three-line="!item.twoLine"
              dense
              @click="item.action"
            >
              <v-list-item-avatar>
                <v-icon :color="item.iconColor" v-text="item.icon"></v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
                <v-list-item-subtitle
                  v-text="item.subtitle"
                ></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-action-text
                  v-text="item.date"
                ></v-list-item-action-text>
                <v-btn small icon @click="removeNotification(item)">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item v-if="!notificationItems.length" one-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >No notifications to show</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <v-spacer></v-spacer>

      <div class="d-flex align-center">
        <!-- RIGHT MENU -->
        <v-menu v-model="mobileMenu" :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" dark depressed color="#262b3e" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list color="#262b3e">
              <div
                v-for="(item, index) in menuItems"
                :key="'appbar_top_' + index"
              >
                <v-list-item @click="mobileMenuAction(item.action)">
                  <v-list-item-avatar dark color="#262b3e">
                    <v-icon color="white" small>{{ item.icon }}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-title class="white--text">{{
                    item.title
                  }}</v-list-item-title>
                </v-list-item>
              </div>
              <v-list-item @click="mobileMenuAction(redirectDocumentation)">
                <v-list-item-avatar dark color="#262b3e">
                  <v-icon color="white" small>mdi-help-circle-outline</v-icon>
                </v-list-item-avatar>
                <v-list-item-action class="mx-0">
                  <p class="white--text">Docs</p>
                </v-list-item-action>
              </v-list-item>

              <v-list-item
                v-for="(item, index) in menuItemsBottom"
                :key="'appbar_bottom_' + index"
                @click="item.action"
              >
                <v-list-item-avatar dark color="#262b3e">
                  <v-icon color="white" small>{{ item.icon }}</v-icon>
                </v-list-item-avatar>
                <v-list-item-title class="white--text">{{
                  item.title
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-action class="mx-0">
                  <v-select
                    v-model="currentProperty"
                    :items="properties"
                    hide-details
                    dense
                    dark
                    outlined
                    @change="changeCurrentProperty"
                  >
                    <template v-slot:append-item>
                      <div class="d-flex flex-column align-center pt-2">
                        <v-btn
                          small
                          class="ma-auto"
                          :disabled="checkPropertyLimit"
                          color="primary"
                          depressed
                          @click="redirectCreateProperty"
                        >
                          <v-icon x-small class="mr-2">mdi-plus</v-icon>New
                          Property
                        </v-btn>
                        <p v-if="checkPropertyLimit" class="caption red--text">
                          Property Limit Reached
                        </p>
                      </div>
                    </template>
                  </v-select>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>
      <v-spacer></v-spacer>
    </v-row>
  </v-app-bar>
</template>

<script>
import { dayjs } from '../util/date'

export default {
  props: ['setMini'],
  data() {
    return {
      properties: [],
      currentProperty: null,
      menuItems: [
        {
          title: 'My Account',
          icon: 'mdi-account-circle',
          action: () => {
            this.redirect('/account')
          }
        },
        {
          title: 'My Property',
          icon: 'mdi-home-city',
          action: () => {
            this.redirect('/property')
          }
        }
      ],
      menuItemsBottom: [
        { title: 'Logout', icon: 'mdi-logout', action: this.logout }
      ],
      notificationItems: [],
      notificationOpen: false,
      mobileMenu: false
    }
  },
  computed: {
    logoUrl() {
      return `${process.env.BASE_URL}images/logo-circle.png`
    },
    user() {
      return this.$store.getters['auth/getUser']
    },
    userName() {
      let name = ''
      if (this.user.firstName) name += this.user.firstName
      if (this.user.lastName) name += ' ' + this.user.lastName
      if (!this.user.firstName && !this.user.lastName && this.user.username)
        name = this.user.username
      return name
    },
    property() {
      return this.$store.getters['properties/getProperty']
    },
    checkPropertyLimit() {
      const propertyLimit = this.user.propertyLimit
      const properties = this.user.properties
      return (
        propertyLimit <=
        properties.filter((prop) => prop.role == 'owner').length
      )
    },
    currentRouteName() {
      return this.$route.name
    },
    breadcrumbs() {
      return [
        {
          text: 'Spacepack'
        },
        {
          text:
            this.currentRouteName.charAt(0).toUpperCase() +
            this.currentRouteName.slice(1)
        }
      ]
    },
    duePdcs() {
      return this.$store.getters['pdcs/getDuePdcs']
    },
    paymentAccess() {
      return this.$root.$roleAccess('payment').access
    },
    pdcAccess() {
      return this.$root.$roleAccess('pdc').access
    },
    pdcAccessAllFeaturesGranted() {
      return (
        this.pdcAccess.read &&
        this.pdcAccess.process &&
        this.pdcAccess.clear &&
        this.pdcAccess.not_clear
      )
    },
    notifications() {
      const notifications =
        this.$store.getters['appBarNotifications/getAppBarNotifications']
      if (notifications) return notifications.notifications || []
      return []
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    duePdcs() {
      if (!this.pdcAccessAllFeaturesGranted) {
        return
      }
      // add PDC notification
      if (this.duePdcs.length) {
        // check uniqueness of pdc notifs
        if (this.notificationItems.some((notif) => notif.id === 'pdc')) {
          return
        }
        this.notificationItems.push({
          date: dayjs(this.duePdcs[0].dueDate).format('MM/DD'),
          id: 'pdc',
          twoLine: true,
          title: 'You have post dated checks due',
          subtitle: 'Click here to take action.',
          icon: 'mdi-checkbook',
          iconColor: 'warning',
          action: () => {
            this.$store.state.pdcs.openProcess = true
            this.$router.push('/pdcs')
          }
        })
      }
    }
  },
  mounted() {
    if (this.user.userType === 'admin') {
      this.menuItems.push({
        title: 'Admin',
        icon: 'mdi-account-lock-outline',
        action: () => {
          this.redirect('/admin')
        }
      })
    }

    if (this.user.property_details && this.property) {
      this.properties = this.user.property_details.map((property) => {
        return { text: property.propertyName, value: property.propertyId }
      })
      this.currentProperty = this.property.propertyId
    }

    this.notificationItems = this.notifications.map((item) => {
      item.date = dayjs(item.startDate).format('MM/DD')
      if (item.id === 'subscription') {
        const subscriptionEnd = dayjs(localStorage.getItem('subscriptionEnd'))
        const subscriptionDiff = subscriptionEnd.diff(dayjs(), 'day') + 1
        const title = `You have ${subscriptionDiff} days left on your subscription`
        const subtitle = `Your subscription is expiring on ${subscriptionEnd.format(
          'MM/DD/YYYY'
        )}. Please contact the developers and update your payment to continue your subscription.`
        item.title = title
        item.subtitle = subtitle
        item.action = () => {
          this.$root
            .$confirm({
              options: {
                color: 'primary',
                width: 500,
                zIndex: 200
              },
              title: title,
              message: subtitle,
              reconfirmOnly: true,
              confirmText: 'Got it!'
            })
            .then((confirm) => {
              if (confirm) {
                this.removeNotification(item)
              }
            })
        }
      }
      return item
    })

    if (this.notificationItems.length) {
      this.$nextTick(() => {
        this.notificationOpen = true
      })
    }
  },
  methods: {
    redirectCreateProperty() {
      this.$router.replace('/new')
    },
    async changeCurrentProperty() {
      if (this.mobile) {
        this.mobileMenu = !this.mobileMenu
      }
      this.$root.$setLoading(true)
      this.$store
        .dispatch('auth/changeCurrentPropertyAction', {
          propertyId: this.currentProperty
        })
        .then(() => {
          this.$root.$setLoading(false)
          window.location.reload()
        })
        .catch((err) => {
          this.$root.$setLoading(false)
          if (err == 'EXPIRED_PROPERTY') {
            this.$router.replace('/expired')
          }
        })
    },
    changeCurrentPropertyMobile(item) {
      this.currentProperty = item.value
      this.changeCurrentProperty()
    },
    redirect(path) {
      this.$router.push(path)
    },
    redirectDocumentation() {
      window.open('https://docs.spacepack.ph/whats-new', '_blank')
    },
    async logout() {
      await this.$store.dispatch('auth/doLogout')
      // this.$router.go()
      window.location.reload()
    },
    removeNotification(item) {
      this.$store.dispatch(
        'appBarNotifications/setReadAppBarNotificationsAction',
        { refNo: item.refNo }
      )
      this.notificationItems.splice(this.notificationItems.indexOf(item), 1)
    },
    mobileMenuAction(action) {
      this.mobileMenu = !this.mobileMenu
      action()
    }
  }
}
</script>

<style scoped>
.v-app-bar {
  border: thin solid rgba(0, 0, 0, 0.12);
  /*background-color: #FFFFFF !important;*/
}
.selection-container {
  width: 20%;
}
.v-input__control {
  min-height: 30px;
}
</style>
